import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';

import get_bits, { arrayIntToString } from '../../../../lib/bytesFunctions';

const mapStateToProps = state => ({
    system: state.system,
});

const _StatoIngressiFilari = ({ system }) => {

    const intl = useIntl();
    const status = !!system ? system.store.status : null;
    if (!status) {
        return (<section></section>);
    }

    const ingressiFilari = [];
    for (let i = 0; i <= 0x22; i++) {
        ingressiFilari.push(system.store[i]);
    }

    return (
        <section>
            <div className="innerSection">
                <h3>
                    <FormattedMessage id="App.info.StatoIngressiFilari" />
                </h3>
                <br />
                <div className="rack">
                    <div className="w100">
                        <form>
                            <fieldset>
                                <table className="controlPanelTable responsiveTable">
                                    <thead>
                                        <tr>
                                            <th><FormattedMessage id="App.info.NomeIngresso" /></th>
                                            <th><FormattedMessage id="App.info.Allarme24h" /></th>
                                            <th><FormattedMessage id="App.info.IngressoAperto" /></th>
                                            <th><FormattedMessage id="App.info.IngressoEscluso" /></th>
                                            <th><FormattedMessage id="App.info.Memoria24h" /></th>
                                            <th><FormattedMessage id="App.info.MemoriaAllarme" /></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: "center" }}>
                                        {ingressiFilari.map((item, index) => {
                                            let name = arrayIntToString(item.split(',').slice(4, 19));
                                            let group = Math.floor(index / 8);
                                            let bit = index % 8;
                                            return (
                                                <tr key={`row_${index}`}>
                                                    <td><span className="head">
                                                        <FormattedMessage id="App.info.NomeIngresso" />
                                                    </span>{`${index + 1} - ${!!name ? name : `${intl.formatMessage({ id: "App.info.IngressoFilare" })} ${index + 1}`}`}</td>
                                                    <td><span className="head">
                                                        <FormattedMessage id="App.info.Allarme24h" />
                                                    </span>{(get_bits(status[`filari_oi24_${group}`], bit) ? 'A' : '')}</td>
                                                    <td><span className="head">
                                                        <FormattedMessage id="App.info.IngressoAperto" />
                                                    </span>{(get_bits(status[`filari_oi_${group}`], bit) ? 'A' : '')}</td>
                                                    <td><span className="head">
                                                        <FormattedMessage id="App.info.IngressoEscluso" />
                                                    </span>{(get_bits(status[`filari_esclusioni_${group}`], bit) ? 'E' : '')}</td>
                                                    <td><span className="head">
                                                        <FormattedMessage id="App.info.Memoria24h" />
                                                    </span>{(get_bits(status[`filari_memorie24_${group}`], bit) ? 'M' : '')}</td>
                                                    <td><span className="head">
                                                        <FormattedMessage id="App.info.Memoria Allarme" />
                                                    </span>{(get_bits(status[`filari_memorie_${group}`], bit) ? 'M' : '')}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
            <p>&nbsp;</p>
        </section>
    );
};

const StatoIngressiFilari = connect(mapStateToProps)(_StatoIngressiFilari);

export default StatoIngressiFilari;